module.exports = __webpack_public_path__ + "static/portfolio-9-a386598295ac43e955f493e8357356bc.jpg";